		<div class="tabs js-tabs" >
			<div class="tabs__head">
				<div class="shell">
					<nav class="tabs__nav" [ngClass]="'tabs__nav--'+ CS.current_tab">
						<ul class="list-actions">
							<li [ngClass]="{'is-active':CS.current_tab=='discover'}">
								<a (click)="toggleTab('discover')" id="discover_trust_link" class="btn">Discover Trust Scores</a>
							</li>
					
							<li [ngClass]="{'is-active':CS.current_tab=='behavior'}">
								<a (click)="toggleTab('behavior')" class="btn btn--green-dark" id="impact_behavior_link"  >Impact Of Trust On Behavior</a>
							</li>
					
							<li [ngClass]="{'is-active':CS.current_tab=='market'}">
								<a (click)="toggleTab('market')" class="btn btn--green" id="impact_market_value_link" >Impact Of Trust On Market Value</a>
							</li>
						</ul><!-- /.list-actions -->
					</nav><!-- /.tabs__nav -->
				</div><!-- /.shell -->
			</div><!-- /.tabs__head -->
			
			<div class="tabs__body" #tabhead id="tabhead">
				<div class="tab"  [ngClass]="{'is-active':CS.current_tab=='discover'}" id="tab1">
					<section class="section section--charts">
						<div class="shell">
							<header class="section__head section__head--alt">
								<h1>Hx TrustID<sup>&trade;</sup> Scorecard</h1>
							</header><!-- /.section__head -->

							<div class="filter">
								<h4 class="filter__title">Filter</h4>

								<ul class="list-selects">
									<li>								
										<div class="select-multi select--checks" [ngClass]="{'is-open': select_open_industry}"
											(click)="toggleSelectOpen('industry');" >
											<label for="field-industry">Industry:</label>
											<div class="select__head">
												<p>Select Industry:</p>
											</div><!-- /.select__head -->

											<div class="select__list" *ngIf="select_open_industry"(mouseleave)="toggleSelectOpen('industry');">
												<ul>
													<li *ngFor="let ind of industries; let i=index" (click)="addItem(ind, 'current_industries');">
														<div class="checkbox checkbox--gray">
															<input type="checkbox"  [checked]="includedItem(ind,'current_industries')" id="industry{{i}}">

															<label for="industry{{i}}">{{ind}}</label>
														</div><!-- /.checkbox -->
													</li>
												</ul>
											</div><!-- /.select__list -->
											
	
										</div><!-- /.select -->
										<div class="cols cols--alt form__cols--size-1">
											<div class="col col--1of3" *ngFor="let selected of current_industries; let j=index" (click)="addItem(selected, 'current_industries');">
												<div class="checkbox" >
													<input type="checkbox"  [checked]="includedItem(selected, 'current_industries')" id="sel{{j}}">
													<label for="sel{{j}}">{{selected}}</label>
												</div><!-- /.checkbox -->
											</div><!-- /.col col-/-1of3 -->

										</div><!-- /.cols -->
									</li>
									
									<li>								
										<div class="select-multi select--checks" [ngClass]="{'is-open': select_open_sector}"
											(click)="toggleSelectOpen('sector');" >
											<label for="field-industry">Sector:</label>
											<div class="select__head">
												<p>Select Sector:</p>
											</div><!-- /.select__head -->

											<div class="select__list" *ngIf="select_open_sector" (mouseleave)="toggleSelectOpen('sector');">
												<ul>
													<li *ngFor="let sect of sectors; let i=index" (click)="addItem(sect, 'current_sectors');">
														<div class="checkbox checkbox--gray">
															<input type="checkbox"  [checked]="includedItem(sect,'current_sectors')" id="sector{{i}}">

															<label for="sector{{i}}">{{sect}}</label>
														</div><!-- /.checkbox -->
													</li>
												</ul>
											</div><!-- /.select__list -->
											
	
										</div><!-- /.select -->
										<div class="cols cols--alt form__cols--size-1">
											<div class="col col--1of3" *ngFor="let selected of current_sectors; let j=index" (click)="addItem(selected, 'current_sectors');">
												<div class="checkbox" >
													<input type="checkbox"  [checked]="includedItem(selected, 'current_sectors')" id="sectsel{{j}}">
													<label for="sectsel{{j}}">{{selected}}</label>
												</div><!-- /.checkbox -->
											</div><!-- /.col col-/-1of3 -->

										</div><!-- /.cols -->
									</li>
									<li [ngClass]="current_sectors.length==0 ? 'hidden-alt':'visible-alt'">								
										<div class="select-multi select--checks" [ngClass]="{'is-open': select_open_category}"
											(click)="toggleSelectOpen('category');" >
											<label for="field-industry">Category:</label>
											<div class="select__head">
												<p>Select Category:</p>
											</div><!-- /.select__head -->

											<div class="select__list" *ngIf="select_open_category" (mouseleave)="toggleSelectOpen('category');">
												<ul>
													<li *ngFor="let cat of categories; let i=index" (click)="addItem(cat, 'current_categories');">
														<div class="checkbox checkbox--gray">
															<input type="checkbox"  [checked]="includedItem(cat,'current_categories')" id="category{{i}}">

															<label for="category{{i}}">{{cat}}</label>
														</div><!-- /.checkbox -->
													</li>
												</ul>
											</div><!-- /.select__list -->
											
	
										</div><!-- /.select -->
										<div class="cols cols--alt form__cols--size-1">
											<div class="col col--1of3" *ngFor="let selected of current_categories; let j=index" (click)="addItem(selected, 'current_categories');">
												<div class="checkbox" >
													<input type="checkbox"  [checked]="includedItem(selected, 'current_categories')" id="catsel{{j}}">
													<label for="catsel{{j}}">{{selected}}</label>
												</div><!-- /.checkbox -->
											</div><!-- /.col col-/-1of3 -->

										</div><!-- /.cols -->
									</li>
								</ul>

								<ul class="list-checkboxes">
									<li>
										<div class="checkbox">
											<input type="checkbox" id="ch-benchmark" [(ngModel)]="industry_visible" />

											<label for="ch-benchmark">Show Best In Class</label>
										</div><!-- /.checkbox -->
									</li>
<!--
									<li>
										<div class="checkbox checkbox--gray" [ngClass]="sector==''?'hidden-alt':'visible-alt'">
											<input type="checkbox" id="ch-average" [(ngModel)]="sector_visible" />

											<label for="ch-average">Show Sector Average</label>
										</div> /.checkbox 
								</li>
-->									</ul><!-- /.list-checkboxes -->
							</div><!-- /.filter -->

							<div class="widget-charts" 
								 [ngClass]="{'show-benchmark': industry_visible, 
											'show-average': sector_visible}">
								<div class="grid">
									<div class="grid__col grid__col--1of2">
										<div class="signal-composite widget-chart is-loaded"  >
											<!--[ngClass]="{'is-loaded': category!==''}"-->
											<div class="chart-circle" id="composite">
												<div class="chart__inner">
													<div class="chart__progress">
														<svg id="svg" width="200" height="200" viewPort="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
															<circle class="bar" r="90" cx="100" cy="100" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0" style="strokeDashoffset:{{current_scores.offset_x}}px"></circle>
														</svg>

														<span class="chart__count">{{current_scores.composite}}</span>
													</div><!-- /.chart__progress -->

													<div class="info-container">
														<p class="benchmark size{{industry_scores.composite}}" >
															<i class="ico-tick-green"></i>

															<em>{{industry_scores.composite}}</em>
														</p><!-- /.benchmakt -->

														<p class="average size{{sector_scores.composite}}">
															<i class="ico-tick-green"></i>

															<em>{{sector_scores.composite}}</em>
														</p><!-- /.benchmakt -->
													</div><!-- /.info-container -->
												</div><!-- /.chart__inner -->

												<p>-100</p>

												<p>100</p>
											</div><!-- /.chart-circle -->

											<h3>
												Composite 

												<span class="gadget-info">
													<i class="ico-info"></i>

													<p>
														The composite score is an average of the Four Factors. It is scored on a scale between –100 to 100.
														
														<em></em>
													</p>
												</span>
											</h3>
										</div><!-- /.widget-chart -->
									</div><!-- /.grid__col -->

									<div class="grid__col grid__col--1of2">
										<ul class="list-charts">
											<li>
												<div class="signal-humanity widget-chart widget-chart--small is-loaded">
													<div class="chart-circle" id="humanity">
														<div class="chart__inner">
															<div class="chart__progress">
																<svg id="svg" width="200" style="color: rgb(11, 100, 109);" height="200" viewPort="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
																	<circle class="bar" r="90" cx="100" cy="100" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0" style="strokeDashoffset:{{current_scores.offset_h}}px"></circle>
																</svg>

																<span class="chart__count">{{current_scores.humanity}}</span>
															</div><!-- /.chart__progress -->

															<div class="info-container">
																<p class="benchmark benchmark--small size{{industry_scores.humanity}}" >
																	<i class="ico-tick-green"></i>

																	<em>{{industry_scores.humanity}}</em>
																</p><!-- /.benchmakt -->

																<p class="average average--small size{{sector_scores.humanity}}">
																	<i class="ico-tick-green"></i>

																	<em>{{sector_scores.humanity}}</em>
																</p><!-- /.benchmakt -->
															</div><!-- /.info-container -->
														</div><!-- /.chart__inner -->

														<p>-100</p>

														<p>100</p>
													</div><!-- /.chart-circle -->

													<h3>
														HUMANITY 

														<span class="gadget-info">
															<i class="ico-info"></i>

															<p>
																Humanity is demonstrating empathy and kindness towards customers and treating everyone fairly. It is scored on a scale between -100 to 100.
																
																<em></em>
															</p>
														</span>
													</h3>
												</div><!-- /.widget-chart -->
											</li>

											<li>
												<div class="signal-capability widget-chart widget-chart--small is-loaded">					<div class="chart-circle" id="capanility">
														<div class="chart__inner">
															<div class="chart__progress">
																<svg id="svg" width="200" height="200" viewPort="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
																	<circle class="bar" r="90" cx="100" cy="100" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0" style="strokeDashoffset:{{current_scores.offset_c}}px" ></circle>
																</svg>

																<span class="chart__count">{{current_scores.capability}}</span>
															</div><!-- /.chart__progress -->

															<div class="info-container">
																<p class="benchmark benchmark--small size{{industry_scores.capability}}" >
																	<i class="ico-tick-green"></i>

																	<em>{{industry_scores.capability}}</em>
																</p><!-- /.benchmakt -->

																<p class="average average--small size{{sector_scores.capability}}">
																	<i class="ico-tick-green"></i>

																	<em>{{sector_scores.capability}}</em>
																</p><!-- /.benchmakt -->
															</div><!-- /.info-container -->
														</div><!-- /.chart__inner -->

														<p>-100</p>

														<p>100</p>
													</div><!-- /.chart-circle -->

													<h3>
														CAPABILITY 

														<span class="gadget-info">
															<i class="ico-info"></i>

															<p>
																Capability is creating quality products, services, and/or experiences. It is scored on a scale  between -100 to 100.
																
																<em></em>
															</p>
														</span>
													</h3>
												</div><!-- /.widget-chart -->
											</li>

											<li>
												<div class="signal-transparency widget-chart widget-chart--small is-loaded">
													<div class="chart-circle" id="transparency">
														<div class="chart__inner">
															<div class="chart__progress">
																<svg id="svg" width="200" height="200" viewPort="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg" >
																	<circle class="bar" r="90" cx="100" cy="100" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0" style="strokeDashoffset:{{current_scores.offset_t}}px;"></circle>
																</svg>

																<span class="chart__count" >{{current_scores.transparency}}</span>
															</div><!-- /.chart__progress -->

															<div class="info-container">
																<p class="benchmark benchmark--small size{{industry_scores.transparency}}" >
																	<i class="ico-tick-green"></i>

																	<em>{{industry_scores.transparency}}</em>
																</p><!-- /.benchmakt -->

																<p class="average average--small size{{sector_scores.transparency}}">
																	<i class="ico-tick-green"></i>

																	<em>{{sector_scores.transparency}}</em>
																</p><!-- /.benchmakt -->
															</div><!-- /.info-container -->
														</div><!-- /.chart__inner -->

														<p>-100</p>

														<p>100</p>
													</div><!-- /.chart-circle -->

													<h3 style="color: rgb(130, 176, 43);">
														TRANSPARENCY 

														<span class="gadget-info">
															<i class="ico-info"></i>

															<p style="background: rgb(130, 176, 43);">
																Transparency is openly sharing all information, motives, and choices in straightforward and plain language. It is scored on a scale between -100 to 100. 
																
																<em></em>
															</p>
														</span>
													</h3>
												</div><!-- /.widget-chart -->
											</li>

											<li>
												<div class="signal-reliability widget-chart widget-chart--small is-loaded">
													<div class="chart-circle" id="reliability">
														<div class="chart__inner">
															<div class="chart__progress">
																<svg id="svg" width="200" height="200" viewPort="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
																	<circle class="bar" r="90" cx="100" cy="100" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0" style="strokeDashoffset:{{current_scores.offset_r}}px"></circle>
																</svg>

																<span class="chart__count">{{current_scores.reliability}}</span>
															</div><!-- /.chart__progress -->

															<div class="info-container">
																<p class="benchmark benchmark--small size{{industry_scores.reliability}}" >
																	<i class="ico-tick-green"></i>

																	<em>{{industry_scores.reliability}}</em>
																</p><!-- /.benchmakt -->

																<p class="average average--small size{{sector_scores.reliability}}">
																	<i class="ico-tick-green"></i>

																	<em>{{sector_scores.reliability}}</em>
																</p><!-- /.benchmakt -->
															</div><!-- /.info-container -->
														</div><!-- /.chart__inner -->

														<p>-100</p>

														<p>100</p>
													</div><!-- /.chart-circle -->

													<h3>
														RELIABILITY 

														<span class="gadget-info">
															<i class="ico-info"></i>

															<p>
																Reliability is consistently and dependably delivering on promises. It is scored on a scale between -100 to 100.
																
																<em></em>
															</p>
														</span>
													</h3>
												</div><!-- /.widget-chart -->
											</li>
										</ul><!-- /.list-charts -->
									</div><!-- /.grid__col -->
								</div><!-- /.grid -->
							</div><!-- /.widget-charts -->
						</div><!-- /.shell -->
					</section><!-- /.section -->
					
					
					<section class="section section--attributes" 
							 
							 >
						<div class="shell">
							<header class="section__head section__head--alt">
								<h1>Hx TrustID<sup>&trade;</sup> Attributes</h1>
							</header><!-- /.section__head -->
							
							
							
							<ng-container *ngIf="current_industries.length==0">
								<p>You must select an Industry to generate this information</p>
							</ng-container>
							<ng-container *ngIf="current_industries.length>1 || current_sectors.length>1 || current_categories.length>0">
								<p>This calculation is only available at the unique Industry/Sector level.  Please remove any category selections and select a single industry or industry/sector combination to view the results</p>
							</ng-container>
							
							<ng-container *ngIf="current_industries.length==1 && current_sectors.length<2 && current_categories.length==0">
								<p>These attributes have a strong impact on your select industry/sector:</p>
							<div class="widget widget-alt" *ngFor="let attr of current_attributes; let i=index">
									<div class="widget__group" [ngClass]="attr.factor">
										<div class="widget__item">
											<div class="widget__bar"><span>#{{i+1}}</span><p>{{attr.factor}}</p></div>

										</div>
										<div class="widget__attr">
											<p>{{attr.attribute}}</p>
										</div>
									</div>
								</div>
							</ng-container>
						</div>
					</section>

						
					<div class="callout">
						<div class="shell">
							<div class="callout__content">
								<p>
									Building trust is your single greatest opportunity to create competitive advantage. With new data at its core, The Four Factors of Trust gives you practical guidance to measure and build trust in the relationships that matter the most—with your customers, workforce, and partners.
								</p>

								<a href="https://www2.deloitte.com/content/dam/Deloitte/global/Documents/the-four-factors-of-trust-excerpt-chapter-one.pdf" target="_blank" id="score__cta" class="btn btn--secondary">Learn More</a>
							</div><!-- /.callout__content -->
						</div><!-- /.shell -->
					</div><!-- /.callout -->

					<section class="section section--bar section--demo">
						<div class="shell">
							<header class="section__head section__head--alt">
								<h1>Hx TrustID<sup>&trade;</sup> Scores By Demographic</h1>
							</header><!-- /.section__head -->

							<div class="filter">
								

								<ul class="list-selects">
									<li>
										<div class="select select--demo">
											<label for="field-demographics">Demographics:</label>

											<select name="field-demographics" id="field-demographics" [(ngModel)]="demographic" (change)="selectDemo();">
												<option value="">Select</option>
												<option *ngFor="let demo of demographics" value="{{demo}}">{{demo}}</option>
											</select>
										</div><!-- /.select -->
									</li>
									
									<li>								
										<div class="select-multi select--checks select--demo" [ngClass]="{'is-open': select_open_industry}"
											(click)="toggleSelectOpen('industry');" >
											<label for="field-industry">Industry:</label>
											<div class="select__head">
												<p>Select Industry:</p>
											</div><!-- /.select__head -->

											<div class="select__list" *ngIf="select_open_industry" (mouseleave)="toggleSelectOpen('industry');">
												<ul>
													<li *ngFor="let ind of industries; let i=index" (click)="addItem(ind, 'current_industries');">
														<div class="checkbox checkbox--gray">
															<input type="checkbox"  [checked]="includedItem(ind,'current_industries')" id="industry{{i}}">

															<label for="industry{{i}}">{{ind}}</label>
														</div><!-- /.checkbox -->
													</li>
												</ul>
											</div><!-- /.select__list -->
											
	
										</div><!-- /.select -->
										<div class="cols cols--alt form__cols--size-1">
											<div class="col col--1of3" *ngFor="let selected of current_industries; let j=index" (click)="addItem(selected, 'current_industries');">
												<div class="checkbox" >
													<input type="checkbox"  [checked]="includedItem(selected, 'current_industries')" id="sel{{j}}">
													<label for="sel{{j}}">{{selected}}</label>
												</div><!-- /.checkbox -->
											</div><!-- /.col col-/-1of3 -->

										</div><!-- /.cols -->
									</li>
									
									<li>								
										<div class="select-multi select--checks  select--demo" [ngClass]="{'is-open': select_open_sector}"
											(click)="toggleSelectOpen('sector');" >
											<label for="field-industry">Sector:</label>
											<div class="select__head">
												<p>Select Sector:</p>
											</div><!-- /.select__head -->

											<div class="select__list" *ngIf="select_open_sector" (mouseleave)="toggleSelectOpen('sector');">
												<ul>
													<li *ngFor="let sect of sectors; let i=index" (click)="addItem(sect, 'current_sectors');">
														<div class="checkbox checkbox--gray">
															<input type="checkbox"  [checked]="includedItem(sect,'current_sectors')" id="sector{{i}}">

															<label for="sector{{i}}">{{sect}}</label>
														</div><!-- /.checkbox -->
													</li>
												</ul>
											</div><!-- /.select__list -->
											
	
										</div><!-- /.select -->
										<div class="cols cols--alt form__cols--size-1">
											<div class="col col--1of3" *ngFor="let selected of current_sectors; let j=index" (click)="addItem(selected, 'current_sectors');">
												<div class="checkbox" >
													<input type="checkbox"  [checked]="includedItem(selected, 'current_sectors')" id="sectsel{{j}}">
													<label for="sectsel{{j}}">{{selected}}</label>
												</div><!-- /.checkbox -->
											</div><!-- /.col col-/-1of3 -->

										</div><!-- /.cols -->
									</li>
									<li [ngClass]="current_sectors.length==0 ? 'hidden-alt':'visible-alt'">								
										<div class="select-multi select--checks  select--demo" [ngClass]="{'is-open': select_open_category}"
											(click)="toggleSelectOpen('category');" >
											<label for="field-industry">Category:</label>
											<div class="select__head">
												<p>Select Category:</p>
											</div><!-- /.select__head -->

											<div class="select__list" *ngIf="select_open_category" (mouseleave)="toggleSelectOpen('category');">
												<ul>
													<li *ngFor="let cat of categories; let i=index" (click)="addItem(cat, 'current_categories');">
														<div class="checkbox checkbox--gray">
															<input type="checkbox"  [checked]="includedItem(cat,'current_categories')" id="category{{i}}">

															<label for="category{{i}}">{{cat}}</label>
														</div><!-- /.checkbox -->
													</li>
												</ul>
											</div><!-- /.select__list -->
											
	
										</div><!-- /.select -->
										<div class="cols cols--alt form__cols--size-1">
											<div class="col col--1of3" *ngFor="let selected of current_categories; let j=index" (click)="addItem(selected, 'current_categories');">
												<div class="checkbox" >
													<input type="checkbox"  [checked]="includedItem(selected, 'current_categories')" id="catsel{{j}}">
													<label for="catsel{{j}}">{{selected}}</label>
												</div><!-- /.checkbox -->
											</div><!-- /.col col-/-1of3 -->

										</div><!-- /.cols -->
									</li>
								
									
								</ul>
							</div><!-- /.filter -->

							<div class="widget-bar">
								<div class="widget__items" id="bar-items">
									<div class="widget__item" *ngFor="let d of current_demo; let x=index">
										<div class="widget__item-bar">
<ng-container *ngIf="d.breakout>0">
<div class="widget__item-bar-inner bar-bg-{{x}}" style="height: {{d.breakout}}%;"></div><!-- /.widget__item-bar-inner-->	
<div class="widget__item-bar-large bar-bg-{{x}}" style="height:{{d.breakout}}%;"></div><!-- /.widget__item-bar-inner -->
</ng-container>
<ng-container *ngIf="d.breakout<0">
<div class="widget__item-bar-inner bar-bg-{{x}}" style="height: {{d.breakout*-1}}%;top:100%"></div><!-- /.widget__item-bar-inner-->	
<div class="widget__item-bar-large bar-bg-{{x}}" style="height:{{d.breakout*-1}}%;top:100%"></div><!-- /.widget__item-bar-inner -->
</ng-container>
										</div><!-- /.widget__item-bar -->

										<div class="widget__item-content">
											<h4>Score: {{d.breakout}}</h4>

											<p>
												{{d.column}}<br><span>(Surveyed: {{d.surveyed}}%)</span>
											</p>
										</div><!-- /.widget__item-content -->
									</div><!-- /.widget__item -->
								</div><!-- /.widget__items -->
							</div><!-- /.widget-charts -->
						</div><!-- /.shell -->
					</section><!-- /.section -->
				</div><!-- /.tab -->

				<div class="tab"  [ngClass]="{'is-active':CS.current_tab=='behavior'}" id="tab2">
					<section class="section section--bars">
						<div class="shell">
							<div class="filter">
								<h4 class="filter__title">Filter</h4>
								<ul class="list-selects list--behavior">
									
									<li>
										<div class="select">
											<label for="field-signal" >Factor:</label>

											<select name="field-signal" id="field-signal" [(ngModel)]="signal" (change)="signalUpdate();">
												<option value="Humanity">Humanity</option>
												<option value="Capability">Capability</option>
												<option value="Transparency">Transparency</option>
												<option value="Reliability">Reliability</option>
												<!--<option value="Composite">Composite</option>-->
											</select>
										</div><!-- /.select -->
									</li>
									<li>								
										<div class="select-multi select--checks" [ngClass]="{'is-open': select_open_industry}"
											(click)="toggleSelectOpen('industry');" >
											<label for="field-industry">Industry:</label>
											<div class="select__head">
												<p>Select Industry:</p>
											</div><!-- /.select__head -->

											<div class="select__list" *ngIf="select_open_industry" (mouseleave)="toggleSelectOpen('industry');">
												<ul>
													<li *ngFor="let ind of industries; let i=index" (click)="addItem(ind, 'current_industries');">
														<div class="checkbox checkbox--gray">
															<input type="checkbox"  [checked]="includedItem(ind,'current_industries')" id="industry{{i}}">

															<label for="industry{{i}}">{{ind}}</label>
														</div><!-- /.checkbox -->
													</li>
												</ul>
											</div><!-- /.select__list -->
											
	
										</div><!-- /.select -->
										<div class="cols cols--alt form__cols--size-1">
											<div class="col col--1of3" *ngFor="let selected of current_industries; let j=index" (click)="addItem(selected, 'current_industries');">
												<div class="checkbox" >
													<input type="checkbox"  [checked]="includedItem(selected, 'current_industries')" id="sel{{j}}">
													<label for="sel{{j}}">{{selected}}</label>
												</div><!-- /.checkbox -->
											</div><!-- /.col col-/-1of3 -->

										</div><!-- /.cols -->
									</li>
									
									<li>								
										<div class="select-multi select--checks" [ngClass]="{'is-open': select_open_sector}"
											(click)="toggleSelectOpen('sector');" >
											<label for="field-industry">Sector:</label>
											<div class="select__head">
												<p>Select Sector:</p>
											</div><!-- /.select__head -->

											<div class="select__list" *ngIf="select_open_sector" (mouseleave)="toggleSelectOpen('sector');">
												<ul>
													<li *ngFor="let sect of sectors; let i=index" (click)="addItem(sect, 'current_sectors');">
														<div class="checkbox checkbox--gray">
															<input type="checkbox"  [checked]="includedItem(sect,'current_sectors')" id="sector{{i}}">

															<label for="sector{{i}}">{{sect}}</label>
														</div><!-- /.checkbox -->
													</li>
												</ul>
											</div><!-- /.select__list -->
											
	
										</div><!-- /.select -->
										<div class="cols cols--alt form__cols--size-1">
											<div class="col col--1of3" *ngFor="let selected of current_sectors; let j=index" (click)="addItem(selected, 'current_sectors');">
												<div class="checkbox" >
													<input type="checkbox"  [checked]="includedItem(selected, 'current_sectors')" id="sectsel{{j}}">
													<label for="sectsel{{j}}">{{selected}}</label>
												</div><!-- /.checkbox -->
											</div><!-- /.col col-/-1of3 -->

										</div><!-- /.cols -->
									</li>
									<li [ngClass]="current_sectors.length==0 ? 'hidden-alt':'visible-alt'">								
										<div class="select-multi select--checks" [ngClass]="{'is-open': select_open_category}"
											(click)="toggleSelectOpen('category');" >
											<label for="field-industry">Category:</label>
											<div class="select__head">
												<p>Select Category:</p>
											</div><!-- /.select__head -->

											<div class="select__list" *ngIf="select_open_category" (mouseleave)="toggleSelectOpen('category');">
												<ul>
													<li *ngFor="let cat of categories; let i=index" (click)="addItem(cat, 'current_categories');">
														<div class="checkbox checkbox--gray">
															<input type="checkbox"  [checked]="includedItem(cat,'current_categories')" id="category{{i}}">

															<label for="category{{i}}">{{cat}}</label>
														</div><!-- /.checkbox -->
													</li>
												</ul>
											</div><!-- /.select__list -->
											
	
										</div><!-- /.select -->
										<div class="cols cols--alt form__cols--size-1">
											<div class="col col--1of3" *ngFor="let selected of current_categories; let j=index" (click)="addItem(selected, 'current_categories');">
												<div class="checkbox" >
													<input type="checkbox"  [checked]="includedItem(selected, 'current_categories')" id="catsel{{j}}">
													<label for="catsel{{j}}">{{selected}}</label>
												</div><!-- /.checkbox -->
											</div><!-- /.col col-/-1of3 -->

										</div><!-- /.cols -->
									</li>
								</ul>
							</div><!-- /.filter -->
							

							<header class="section__head section__head--alt">
								<h3>When A Brand Is Perceived To Have</h3>

								<h1>High {{signal}} Trust Factor</h1>

								<h3>Vs. Neutral {{signal}} Trust Factor</h3>
							</header><!-- /.section__head -->

							<div class="widget-alt" id="widget-impact" >
								<div class="widget__group">
									<h2 class="widget__title">Purchase</h2><!-- /.widget__title -->

									<div class="widget__item">
										<div class="widget__bar">
											<span>{{figureIt('Purch',signal)}}x</span>

											<p>Customers who rate a brand high in {{signal}} trust factor are {{figureIt('Purch',signal)}}x {{figureIt('Purch',signal)>1? 'more ':  ''}}likely to <strong>purchase a new product or service from that brand</strong></p>
											
										</div><!-- /.widget__bar -->

										<h4 class="widget__subtitle">Customers with...</h4><!-- /.widget__subtitle -->

										<ul class="widget__bars">
											<li>
												<h4>
													High
													{{signal}}
												</h4>

												<div class="widget__bar-progress">
													<span style="width:{{graphIt('Purch',signal,'Agree')}}%"></span>   <strong>{{graphIt('Purch',signal,'Agree')}}%</strong>
												</div><!-- /.widget__bar-progress -->
											</li>

											<li>
												<h4>
													NEUTRAL
													{{signal}}
												</h4>

												<div class="widget__bar-progress">
													<span style="width:{{graphIt('Purch',signal,'Disagree')}}%"></span>   <strong>{{graphIt('Purch',signal,'Disagree')}}%</strong>
												</div><!-- /.widget__bar-progress -->
											</li>
										</ul><!-- /.widget__bars -->
									</div><!-- /.widget__item -->

									<div class="widget__item">
										<div class="widget__bar">
											<span>{{figureIt('PurchStrong',signal)}}x</span>

											<p>Customers who rate a brand high in {{signal}} trust factor are {{figureIt('PurchStrong',signal)}}x {{figureIt('PurchStrong',signal)>1? 'more ':  ''}}likely to <strong>frequently choose that brand over competitors</strong></p>
										</div><!-- /.widget__bar -->

										<h4 class="widget__subtitle">Customers with...</h4><!-- /.widget__subtitle -->

										<ul class="widget__bars">
											<li>
												<h4>
													High
													{{signal}}
												</h4>

												<div class="widget__bar-progress">
													<span style="width:{{graphIt('PurchStrong',signal,'Agree')}}%"></span>  <strong>{{graphIt('PurchStrong',signal,'Agree')}}%</strong>
												</div><!-- /.widget__bar-progress -->
											</li>

											<li>
												<h4>
													NEUTRAL
													{{signal}}
												</h4>

												<div class="widget__bar-progress">
													<span style="width:{{graphIt('PurchStrong',signal,'Disagree')}}%"></span>  <strong>{{graphIt('PurchStrong',signal,'Disagree')}}%</strong>
												</div><!-- /.widget__bar-progress -->
											</li>
										</ul><!-- /.widget__bars -->
									</div><!-- /.widget__item -->
								</div><!-- /.widget__group -->

								<div class="widget__group">
									<h2 class="widget__title">ADVOCACY</h2><!-- /.widget__title -->

									<div class="widget__item">
										<div class="widget__bar">
											<span>{{figureIt('Adv',signal)}}x</span>
											<p>Customers who rate a brand high in {{signal}} trust factor are {{figureIt('Adv',signal)}}x {{figureIt('Adv',signal)>1? 'more ':  ''}}likely to <strong>defend that brand</strong> than customers who rate the brand neutral or low</p>
										</div><!-- /.widget__bar -->

										<h4 class="widget__subtitle">Customers with...</h4><!-- /.widget__subtitle -->

										<ul class="widget__bars">
											<li>
												<h4>
													High
													{{signal}}
												</h4>

												<div class="widget__bar-progress">
													<span style="width:{{graphIt('Adv',signal,'Agree')}}%"></span>   <strong>{{graphIt('Adv',signal,'Agree')}}%</strong>
												</div><!-- /.widget__bar-progress -->
											</li>

											<li>
												<h4>
													NEUTRAL
													{{signal}}
												</h4>

												<div class="widget__bar-progress">
													<span style="width:{{graphIt('Adv',signal,'Disagree')}}%"></span>   <strong>{{graphIt('Adv',signal,'Disagree')}}%</strong>
												</div><!-- /.widget__bar-progress -->
											</li>
										</ul><!-- /.widget__bars -->
									</div><!-- /.widget__item -->

									<div class="widget__item">
										<div class="widget__bar">
											<span>{{figureIt('AdvStrong',signal)}}x</span>

											<p>Customers who rate a brand high in {{signal}} trust factor are {{figureIt('AdvStrong',signal)}}x {{figureIt('AdvStrong',signal)>1? 'more ':  ''}}likely to <strong>positively comment or rate that brand on social media</strong></p>
										</div><!-- /.widget__bar -->

										<h4 class="widget__subtitle">Customers with...</h4><!-- /.widget__subtitle -->

										<ul class="widget__bars">
											<li>
												<h4>
													High
													{{signal}}
												</h4>

												<div class="widget__bar-progress">
													<span style="width:{{graphIt('AdvStrong',signal,'Agree')}}%"></span>   <strong>{{graphIt('AdvStrong',signal,'Agree')}}%</strong>
												</div><!-- /.widget__bar-progress -->
											</li>

											<li>
												<h4>
													NEUTRAL
													{{signal}}
												</h4>

												<div class="widget__bar-progress">
													<span style="width:{{graphIt('AdvStrong',signal,'Disagree')}}%"></span>   <strong>{{graphIt('AdvStrong',signal,'Disagree')}}%</strong>
												</div><!-- /.widget__bar-progress -->
											</li>
										</ul><!-- /.widget__bars -->
									</div><!-- /.widget__item -->
								</div><!-- /.widget__group -->

								<div class="widget__group">
									<h2 class="widget__title">SERVICE RECOVERY</h2><!-- /.widget__title -->

									<div class="widget__item">
										<div class="widget__bar">
											<span>{{figureIt('Service',signal)}}x</span>

											<p>Customers who rate a brand high in {{signal}} trust factor are {{figureIt('Service',signal)}}x {{figureIt('Service',signal)>1? 'more ':  ''}}likely to <strong>continue purchasing from or using the brand despite a previous data breach.</strong></p>
											
										</div><!-- /.widget__bar -->

										<h4 class="widget__subtitle">Customers with...</h4><!-- /.widget__subtitle -->

										<ul class="widget__bars">
											<li>
												<h4>
													High
													{{signal}}
												</h4>

												<div class="widget__bar-progress">
													<span style="width:{{graphIt('Service',signal,'Agree')}}%"></span>   <strong>{{graphIt('Service',signal,'Agree')}}%</strong>
												</div><!-- /.widget__bar-progress -->
											</li>

											<li>
												<h4>
													NEUTRAL
													{{signal}}
												</h4>

												<div class="widget__bar-progress">
													<span style="width:{{graphIt('Service',signal,'Disagree')}}%"></span>   <strong>{{graphIt('Service',signal,'Disagree')}}%</strong>
												</div><!-- /.widget__bar-progress -->
											</li>
										</ul><!-- /.widget__bars -->
									</div><!-- /.widget__item -->

									<div class="widget__item">
										<div class="widget__bar">
											<span>{{figureIt('ServiceStrong',signal)}}x</span>
											<p>Customers who rate a brand high in {{signal}} trust factor are {{figureIt('ServiceStrong',signal)}}x {{figureIt('ServiceStrong',signal)>1? 'more ':  ''}}likely to <strong>stick with the brand after a mistake was made.</strong> </p>
										</div><!-- /.widget__bar -->

										<h4 class="widget__subtitle">Customers with...</h4><!-- /.widget__subtitle -->

										<ul class="widget__bars">
											<li>
												<h4>
													High
													{{signal}}
												</h4>

												<div class="widget__bar-progress">
													<span style="width:{{graphIt('ServiceStrong',signal,'Agree')}}%"></span>   <strong>{{graphIt('ServiceStrong',signal,'Agree')}}%</strong>
												</div><!-- /.widget__bar-progress -->
											</li>

											<li>
												<h4>
													NEUTRAL
													{{signal}}
												</h4>

												<div class="widget__bar-progress">
													<span style="width:{{graphIt('ServiceStrong',signal,'Disagree')}}%"></span>   <strong>{{graphIt('ServiceStrong',signal,'Disagree')}}%</strong>
												</div><!-- /.widget__bar-progress -->
											</li>
										</ul><!-- /.widget__bars -->
									</div><!-- /.widget__item -->
								</div><!-- /.widget__group -->
							</div><!-- /.widget-alt -->
						</div><!-- /.shell -->
					</section><!-- /.section -->
				</div><!-- /.tab -->

				<div class="tab"  [ngClass]="{'is-active':CS.current_tab=='market'}" id="tab3">
					<section class="section section--trust">
						<div class="shell">
							<header class="section__head section__head--alt">
								<h1>MARKET VALUE IMPACT OF TRUST</h1>
							</header><!-- /.section__head -->

							<div class="filter">
								<h4 class="filter__title">Filter</h4>
								
								<ul class="list-selects">
									<li>								
										<div class="select-multi select--checks " [ngClass]="{'is-open': select_open_industry}"
											(click)="toggleSelectOpen('industry');" >
											<label for="field-industry">Industry:</label>
											<div class="select__head">
												<p>Select Industry:</p>
											</div><!-- /.select__head -->

											<div class="select__list" *ngIf="select_open_industry" (mouseleave)="toggleSelectOpen('industry');">
												<ul>
													<li *ngFor="let ind of industries; let i=index" (click)="addItem(ind, 'current_industries');">
														<div class="checkbox checkbox--gray">
															<input type="checkbox"  [checked]="includedItem(ind,'current_industries')" id="industry{{i}}">

															<label for="industry{{i}}">{{ind}}</label>
														</div><!-- /.checkbox -->
													</li>
												</ul>
											</div><!-- /.select__list -->
											
	
										</div><!-- /.select -->
										<div class="cols cols--alt form__cols--size-1">
											<div class="col col--1of3" *ngFor="let selected of current_industries; let j=index" (click)="addItem(selected, 'current_industries');">
												<div class="checkbox" >
													<input type="checkbox"  [checked]="includedItem(selected, 'current_industries')" id="sel{{j}}">
													<label for="sel{{j}}">{{selected}}</label>
												</div><!-- /.checkbox -->
											</div><!-- /.col col-/-1of3 -->

										</div><!-- /.cols -->
									</li>
									
									<li>								
										<div class="select-multi select--checks " [ngClass]="{'is-open': select_open_sector}"
											(click)="toggleSelectOpen('sector');" >
											<label for="field-industry">Sector:</label>
											<div class="select__head">
												<p>Select Sector:</p>
											</div><!-- /.select__head -->

											<div class="select__list" *ngIf="select_open_sector" (mouseleave)="toggleSelectOpen('sector');">
												<ul>
													<li *ngFor="let sect of sectors; let i=index" (click)="addItem(sect, 'current_sectors');">
														<div class="checkbox checkbox--gray">
															<input type="checkbox"  [checked]="includedItem(sect,'current_sectors')" id="sector{{i}}">

															<label for="sector{{i}}">{{sect}}</label>
														</div><!-- /.checkbox -->
													</li>
												</ul>
											</div><!-- /.select__list -->
											
	
										</div><!-- /.select -->
										<div class="cols cols--alt form__cols--size-1">
											<div class="col col--1of3" *ngFor="let selected of current_sectors; let j=index" (click)="addItem(selected, 'current_sectors');">
												<div class="checkbox" >
													<input type="checkbox"  [checked]="includedItem(selected, 'current_sectors')" id="sectsel{{j}}">
													<label for="sectsel{{j}}">{{selected}}</label>
												</div><!-- /.checkbox -->
											</div><!-- /.col col-/-1of3 -->

										</div><!-- /.cols -->
									</li>
									<li [ngClass]="current_sectors.length==0 ? 'hidden-alt':'visible-alt'">								
										<div class="select-multi select--checks  " [ngClass]="{'is-open': select_open_category}"
											(click)="toggleSelectOpen('category');" >
											<label for="field-industry">Category:</label>
											<div class="select__head">
												<p>Select Category:</p>
											</div><!-- /.select__head -->

											<div class="select__list" *ngIf="select_open_category" (mouseleave)="toggleSelectOpen('category');">
												<ul>
													<li *ngFor="let cat of categories; let i=index" (click)="addItem(cat, 'current_categories');">
														<div class="checkbox checkbox--gray">
															<input type="checkbox"  [checked]="includedItem(cat,'current_categories')" id="category{{i}}">

															<label for="category{{i}}">{{cat}}</label>
														</div><!-- /.checkbox -->
													</li>
												</ul>
											</div><!-- /.select__list -->
											
	
										</div><!-- /.select -->
										<div class="cols cols--alt form__cols--size-1">
											<div class="col col--1of3" *ngFor="let selected of current_categories; let j=index" (click)="addItem(selected, 'current_categories');">
												<div class="checkbox" >
													<input type="checkbox"  [checked]="includedItem(selected, 'current_categories')" id="catsel{{j}}">
													<label for="catsel{{j}}">{{selected}}</label>
												</div><!-- /.checkbox -->
											</div><!-- /.col col-/-1of3 -->

										</div><!-- /.cols -->
									</li>

								</ul>


								<ul class="list-fields">
									<li>
										<div class="field-box">
											<label for="field1">Estimated Market Capitalization</label>

											<input type="text" class="field" name="field1mkt" id="field1mkt" (focus)="market_str=''" (blur)="transformAmount($event)" (keypress)="keyPressNumbers($event)" [(ngModel)]="market_str"  />
										</div><!-- /.checkbox -->
									</li>

									<li>
										<div class="field-box">
											<label for="field2">Market Value Inputs: <span> What is your expected % stock return? </span></label>

											<input type="text" class="field" name="field2" id="field2" (focus)="stock_str=''" (blur)="transformStock($event)" (keypress)="keyPressNumbers($event)" [(ngModel)]="stock_str" />
										</div><!-- /.checkbox -->
									</li>

<!--									<li>
										<div class="field-box">
											<label for="field3">Stock Ticker</label>

											<input type="text" class="field" name="field3" id="field3" placeholder="META" />
										</div><!-- /.checkbox -->
<!--									</li>-->
								</ul><!-- /.list-fields -->

<!--								<div class="filter__actions">
									<a href="#" class="btn btn--green btn--large">Calculate my Market Impact</a>
								</div> /.filter__actions -->
							</div><!-- /.filter -->	
						
						</div><!-- /.shell -->
					</section><!-- /.section -->

					<div class="widget-def">
						<div class="shell">
							<div class="widget__head">
								<p>
									A one-point increase in HX TrustID<sup>&trade;</sup> Score could<br>
									INCREASE EXPECTED MARKET CAPITALIZATION BY
								</p>
													
								<div class="potential-rev"
									 [ngClass]="{'rev_millions': market.increase>999999}"
									 >{{market.increase|currency:'USD':'symbol':'1.0-0'}}</div>

								<!--<img src="assets/images/temp/5.png" alt="" />-->

								<h4>Based on an initial HX TrustID<sup>&trade;</sup> score of {{current_scores.composite}}*</h4>

								<h6 class="widget__hint">
									*{{category!==''? 'Category ('+category+')': sector!==''? 'Sector ('+sector+')': 'Industry'}} Average HX TrustID<sup>&trade;</sup> Score
								</h6><!-- /.widget__hint -->
							</div><!-- /.widget__head -->

							<div class="widget__body">
								<ul class="widget__y">
									<li>${{market.scale_max| thousandSuff : 1}}</li>
									
									<li>${{(5*market.scale_step)| thousandSuff : 1}}</li>
									
									<li>${{(4*market.scale_step)| thousandSuff : 1}}</li>
									
									<li>${{(3*market.scale_step)| thousandSuff : 1}}</li>
									
									<li>${{(2*market.scale_step)| thousandSuff : 1}}</li>
									
									<li>${{market.scale_step| thousandSuff : 1}}</li>
									
									<li>$0</li>
								</ul><!-- /.widget__y -->

								<div class="widget__items">
									<div class="widget__item" id="current-cap">
										<div class="widget__item-bar">
											<span style="height:{{(market_num/market.scale_max)*100}}%;
														 width:{{(market_num/market.scale_max)*100}}%;"></span>
										</div><!-- /.widget__item-bar -->

										<div class="widget__item-content">
											<h4>${{market_num| thousandSuff : 1}}</h4>
											
											<p>
												Current Market <br>
												Capitalization
											</p>
										</div><!-- /.widget__item-content -->
									</div><!-- /.widget__item -->

									<div class="widget__item is-active" id="estimated-cap">
										<div class="widget__item-bar">
											<span style="height:{{(market.new/market.scale_max)*100}}%;
														 width:{{(market.new/market.scale_max)*100}}%;">
												<em>${{market.increase| thousandSuff : 1}}</em>
											</span>
										</div><!-- /.widget__item-bar -->

										<div class="widget__item-content">
											<h4>${{market.new| thousandSuff : 3}}</h4>

											<p>
												Estimated Market <br>
												Capitalization
											</p>
										</div><!-- /.widget__item-content -->
									</div><!-- /.widget__item -->
								</div><!-- /.widget__items -->
							</div><!-- /.widget__body -->

							<div class="widget__foot">
								<ul class="widget__legend">
									<li style="color: #C3D989;">
										<span style="background: #C3D989;"></span>

										Current Market Capitalization
									</li> 

									<li style="color: #AEB0B3;">
										<span style="background: #AEB0B3;"></span>

										Market Capitalization based on current expected stock return
									</li>

									<li style="color: #D6EDE1;">
										<span style="background: #D6EDE1;"></span>

										Incremental Market Capitalization with one-point trust increase
									</li>
								</ul><!-- /.widget__legend -->

								<p>Market value increase estimates are based on a regression analysis conducted on a benchmark dataset</p>
							</div><!-- /.widget__foot -->
						</div><!-- /.shell -->
					</div><!-- /.widget-def -->
				</div><!-- /.tab -->
			</div><!-- /.tabs__body -->
		</div><!-- /.tabs js-tabs -->

		<div class="callout callout--alt">
			<div class="shell">
				<div class="callout__content" *ngIf="CS.current_tab=='discover'">
					<h3>Implement Trust Today</h3>

					<p>
						Are you ready to identify your strengths and trust deficits so you start closing the trust gaps in your organization?
					</p>		
					<a href="https://www2.deloitte.com/us/en/pages/about-deloitte/solutions/four-factors-of-trust.html" target="_blank" class="btn btn--teritary" id="implement_trust_cta">Learn More</a>  
				<!--	<a href="https://www2.deloitte.com/global/en/pages/about-deloitte/solutions/hx-trust-id.html" target="_blank" class="btn btn--teritary" id="implement_trust_cta">Learn More</a>-->
				</div><!-- /.callout__content -->
				<div class="callout__content" *ngIf="CS.current_tab=='behavior'">
					<h3>Impact Customer and Employee behavior</h3>

					<p>
						Trust has been 74% effective in predicting behavior. Interested in how we can work with your organization improve trust? Click here to get in contact with us.
					</p>					
					<a href="mailto:usexperiencemanagement@deloitte.com"  id="implement_behavior_cta" class="btn btn--teritary">Contact Us</a>
				</div><!-- /.callout__content -->
				<div class="callout__content" *ngIf="CS.current_tab=='market'">
					<h3>Learn how to action on this market impact today!</h3>
					<p>Are you ready to start building trust today? Learn more about the trust-building actions that fuel growth and market performance. </p>

					<a href="https://www2.deloitte.com/global/en/pages/about-deloitte/solutions/hx-trust-id.html" target="_blank" class="btn btn--teritary"  id="implement_market_impact_cta">Learn More</a>
				</div><!-- /.callout__content -->
			</div><!-- /.shell -->
		</div><!-- /.callout -->
